import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthDialogProvider } from './contexts/AuthDialogContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AuthDialog from './components/AuthDialog';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';

import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Masterclasses from './pages/Masterclasses';
import About from './pages/About';
import Contact from './pages/Contact';
import Newsletter from './pages/Newsletter';
import DashboardOverview from './pages/dashboard/DashboardOverview';
import DashboardProfile from './pages/dashboard/DashboardProfile';
import DashboardPurchases from './pages/dashboard/DashboardPurchases';

import { Toaster } from 'sonner';
import './App.css';

const PublicShell = () => (
  <>
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:courseId" element={<CourseDetail />} />
      <Route path="/masterclasses" element={<Masterclasses />} />
      <Route path="/internships" element={<Navigate to="/" replace />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/newsletter" element={<Newsletter />} />
    </Routes>
    <Footer />
  </>
);

const LearnerShell = () => (
  <ProtectedRoute>
    <DashboardLayout />
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AuthDialogProvider>
            <Toaster position="bottom-right" theme="dark" richColors closeButton />
            <ScrollToTop />
            <AuthDialog />
            <Routes>
              <Route element={<LearnerShell />}>
                <Route path="/my-learning" element={<DashboardOverview />} />
                <Route path="/profile" element={<DashboardProfile />} />
                <Route path="/purchases" element={<DashboardPurchases />} />
                <Route path="/internship" element={<Navigate to="/my-learning" replace />} />
              </Route>
              <Route path="/dashboard" element={<Navigate to="/my-learning" replace />} />
              <Route path="/dashboard/*" element={<Navigate to="/my-learning" replace />} />
              <Route path="/*" element={<PublicShell />} />
            </Routes>
          </AuthDialogProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
